export default {
  init() {
    // var items = document.querySelectorAll('.woocommerce-cart-form__cart-item');
    var btn = document.querySelector('[name="update_cart"]');

    function triggerEvent(elem, type, event) {
      event = document.createEvent("MouseEvents");
      event.initMouseEvent(type, true, true, elem.ownerDocument.defaultView,
        0, 0, 0, 0, 0, false, false, false, false, 0, null);
      elem.dispatchEvent(event);
    }

    const on = (selector, eventType, childSelector, eventHandler) => {
      const elements = document.querySelectorAll(selector);

      elements.forEach(element => {
        element.addEventListener(eventType, eventOnElement => {
          if (eventOnElement.target.matches(childSelector)) {
            eventHandler(eventOnElement)
          }
        })
      });
    }

    on('.woocommerce', 'click', '.qty--plus', (e) => {
      var element = e.target;
      var wrapper = element.closest('.quantity');
      var quantity = wrapper.querySelector('.qty');

      var oldValue = quantity.value;
      var newVal = parseFloat(oldValue) + 1;

      quantity.value = newVal;
      triggerEvent(quantity, "change", event);
      btn.disabled = false;
      btn.setAttribute('aria-disabled', false);

      setTimeout(() => {
        document.querySelector('[name="update_cart"]').click();
      }, 200);

    })

    on('.woocommerce', 'click', '.qty--minus', (e) => {
      var element = e.target;
      var wrapper = element.closest('.quantity');
      var quantity = wrapper.querySelector('.qty');

      var oldValue = quantity.value;
      var newVal = parseFloat(oldValue) - 1;

      quantity.value = newVal;
      triggerEvent(quantity, "change", event);
      btn.disabled = false;
      btn.setAttribute('aria-disabled', false);

      setTimeout(() => {
        document.querySelector('[name="update_cart"]').click();
      }, 200);


    })
      

    // items.forEach(item => {
      
    //   var minus = item.querySelector('.qty--minus');
    //   var plus = item.querySelector('.qty--plus');


    //   plus.addEventListener('click', function () {
    //     var oldValue = quantity.value;
    //     var newVal = parseFloat(oldValue) + 1;

    //     quantity.value = newVal;
    //     triggerEvent(quantity, "change", event);
    //     btn.click();

    //   })

    //   minus.addEventListener('click', function () {
    //     var oldValue = quantity.value;
    //     var newVal;

    //     if (oldValue > 0) {
    //       newVal = parseFloat(oldValue) - 1;
    //     } else {
    //       newVal = 0;
    //     }
    //     quantity.value = newVal;
    //     triggerEvent(quantity, "change", event);
    //     btn.click();

    //   })
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-cart.js